// extracted by mini-css-extract-plugin
export default {"component":"QuickPresentationAddComponent_component__IQfqo","explaining":"QuickPresentationAddComponent_explaining__gEHn3"};